import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ApiService } from 'src/app/services/api/api.service';
import { LegendPosition } from '@swimlane/ngx-charts';
import { finalize } from 'rxjs';
import { ConfirmActionComponent } from 'src/app/shared/components/confirm-action/confirm-action.component';
import { ErrorModalComponent } from 'src/app/shared/modals/error-modal/error-modal.component';
import { SuccessModalComponent } from 'src/app/shared/modals/success-modal/success-modal.component';
import { AuthService } from 'src/app/services/auth/auth.service';

@Component({
  selector: 'app-marriage-registration-details-modal',
  standalone: false,
  templateUrl: './marriage-registration-details-modal.component.html',
  styleUrl: './marriage-registration-details-modal.component.scss'
})
export class MarriageRegistrationDetailsModalComponent {

  form: FormGroup;
  isQueryingApplication: boolean;
  isApprovingApplication: boolean;

  constructor(
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<MarriageRegistrationDetailsModalComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    private apiService: ApiService,
    private formBuilder: FormBuilder,
    private authService: AuthService
  ) { }

  ngOnInit(): void {

    this.initializeForm();

    this.patchForm(this.dialogData)
  }

  initializeForm() {
    this.form = this.formBuilder.group({
      // === File Uploads ===
    oathCertificate: [null],


    bachelorBirthCertificate: [null],
    bachelorDeclarationOfAge: [null],
    bachelorPassportPhotograph: [null],
    bachelorIndigeneCertificate: [null],
    bachelorInternationalPassport: [null],

    // === Bachelor ===
    bachelorFirstName: [''],
    bachelorMiddleName: [''],
    bachelorSurname: [''],
    bachelorPhoneNumber: [''],
    bachelorDob: [''],
    bachelorCountry: [null],
    bachelorState: [null],
    bachelorLga: [null],
    bachelorAddress: [''],
    bachelorSignature: [null],
    bachelorHasAnotherMarriage: [false],
    bachelorIsWidower: [false],
    bachelorIsDivorce: [false],
    bachelorHasChild: [false],


    bachelorWitnessMiddleName: [''],
    bachelorWitnessSurname: [''],
    bachelorWitnessFirstName: [''],
    bachelorWitnessEmail: [''],
    bachelorWitnessPhoneNumber: [''],
    bachelorWitnessAddress: [''],
    bachelorWitnessSignature: [null],

    // === Spinster ===
    spinsterBirthCertificate: [null],
    spinsterDeclarationOfAge: [null],
    spinsterPassportPhotograph: [null],
    spinsterIndigeneCertificate: [null],
    spinsterInternationalPassport: [null],


    spinsterFirstName: [''],
    spinsterMiddleName: [''],
    spinsterSurname: [''],
    spinsterPhoneNumber: [''],
    spinsterDob: [''],
    spinsterCountry: [null],
    spinsterState: [null],
    spinsterLga: [null],
    spinsterAddress: [''],
    spinsterSignature: [null],
    spinsterHasAnotherMarriage: [false],
    spinsterIsWidow: [false],
    spinsterIsDivorce: [false],
    spinsterHasChild: [false],



    spinsterWitnessFirstName: [''],
    spinsterWitnessSurname: [''],
    spinsterWitnessMiddleName: [''],
    spinsterWitnessEmail: [''],
    spinsterWitnessPhoneNumber: [''],
    spinsterWitnessAddress: [''],
    spinsterWitnessSignature: [null],
    });
  }

  closeModal(): void {

      this.dialogRef.close();

  }



  patchForm(data: any) {

    const bachelorWitness = data.bachelor?.witness;
    const spinsterWitness = data.spinster?.witness;

    this.form.patchValue({

      oathCertificate: data?.oathCertificate || '',

      bachelorBirthCertificate: data?.bachelor?.bachelorBirthCertificate || '',
      bachelorDeclarationOfAge: data?.bachelor?.bachelorDeclarationOfAge || '',
      bachelorPassportPhotograph: data?.bachelor?.bachelorPassportPhotograph || '',
      bachelorIndigeneCertificate: data?.bachelor?.bachelorIndigeneCertificate || '',
      bachelorInternationalPassport: data?.bachelor?.bachelorInternationalPassport || '',

      // === Bachelor
      bachelorFirstName: data?.bachelor?.firstName || '',
      bachelorMiddleName: '',
      bachelorSurname: data?.bachelor?.lastName || '',
      bachelorPhoneNumber: data?.bachelor?.phoneNumber || '',
      bachelorDob: data?.bachelor?.dob || '',
      bachelorCountry: data?.bachelor?.country || '',
      bachelorState: data?.bachelor?.state || '',
      bachelorLga: data?.bachelor?.lga || '',
      bachelorAddress: data?.bachelor?.address || '',
      bachelorSignature: data?.bachelor?.signature || '',
      bachelorHasAnotherMarriage: data?.bachelor?.hasAnotherMarriage || false,
      bachelorIsWidower: data?.bachelor?.isWidower || false,
      bachelorIsDivorce: data?.bachelor?.isDivorce || false,
      bachelorHasChild: data?.bachelor?.hasChild || false,

      bachelorWitnessFirstName: bachelorWitness?.firstName || '',
      bachelorWitnessMiddleName: bachelorWitness?.middleName || '',
      bachelorWitnessSurname: bachelorWitness?.lastName || '',
      bachelorWitnessEmail: bachelorWitness?.email || '',
      bachelorWitnessPhoneNumber: bachelorWitness?.phoneNumber || '',
      bachelorWitnessAddress: bachelorWitness?.address || '',
      bachelorWitnessSignature: bachelorWitness?.signature || '',

      // === Spinster
      spinsterBirthCertificate: data?.spinster?.spinsterBirthCertificate || '',
      spinsterDeclarationOfAge: data?.spinster?.spinsterDeclarationOfAge || '',
      spinsterPassportPhotograph: data?.spinster?.spinsterPassportPhotograph || '',
      spinsterIndigeneCertificate: data?.spinster?.spinsterIndigeneCertificate || '',
      spinsterInternationalPassport: data?.spinster?.spinsterInternationalPassport || '',

      spinsterFirstName: data?.spinster?.firstName || '',
      spinsterMiddleName: '',
      spinsterSurname: data?.spinster?.lastName || '',
      spinsterPhoneNumber: data?.spinster?.phoneNumber || '',
      spinsterDob: data?.spinster?.dob || '',
      spinsterCountry: data?.spinster?.country || '',
      spinsterState: data?.spinster?.state || '',
      spinsterLga: data?.spinster?.lga || '',
      spinsterAddress: data?.spinster?.address || '',
      spinsterSignature: data?.spinster?.signature || '',
      spinsterHasAnotherMarriage: data?.spinster?.hasAnotherMarriage || false,
      spinsterIsWidow: data?.spinster?.isWidow || false,
      spinsterIsDivorce: data?.spinster?.isDivorce || false,
      spinsterHasChild: data?.spinster?.hasChild || false,

      spinsterWitnessFirstName: spinsterWitness?.firstName || '',
      spinsterWitnessMiddleName: spinsterWitness?.middleName || '',
      spinsterWitnessSurname: spinsterWitness?.lastName || '',
      spinsterWitnessEmail: spinsterWitness?.email || '',
      spinsterWitnessPhoneNumber: spinsterWitness?.phoneNumber || '',
      spinsterWitnessAddress: spinsterWitness?.address || '',
      spinsterWitnessSignature: spinsterWitness?.signature || '',
    });






    this.form.disable();
  }

  hasAccess(permissions: string[]) {
    return this.authService.hasAnyPermission(permissions)
  }

  openErrorModal(message: string) {
    let dialogRef = this.dialog.open(ErrorModalComponent, {
      width: '350px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form'],
      data: { errorMessage: message },
    });

    dialogRef.afterClosed().subscribe(() => { });
  }

  openSuccessModal(message: string) {
    let dialogRef = this.dialog.open(SuccessModalComponent, {
      width: '350px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form'],
      data: { successMessage: message },
    });

    dialogRef.afterClosed().subscribe(() => {
      this.dialogRef.close({reload: true});
    });
  }

  queryApplication() {
    const formValues = this.form.value;

    this.openConfirmationModal({
      title: 'Are you sure you want to decline this application?',
      onConfirm: () => {

        this.isQueryingApplication = true;

        this.apiService.post('/workflow/get-next-approving-officer', {
          entityId: this.dialogData?.id,
          workflowName: 'MARRIAGE_REGISTRATION',
          type: 'QUERIED'
        }).pipe(
          finalize(() => {
            this.isQueryingApplication = false;
          })
        ).subscribe((res) => {
          if (res.success) {
            this.openSuccessModal(res.message || 'Application queried successfully')
          }
          else {
            this.openErrorModal(res?.error || res?.message);

          }
        },
          (error) => {
            this.openErrorModal(error || 'Unable to decline application');
          })
      },
      onCancel: () => console.log('Declined action cancelled'),
    });
  }

  openConfirmationModal({
    title,
    onConfirm,
    onCancel = () => { },
  }: {
    title: string;
    onConfirm: () => void;
    onCancel?: () => void;
  }) {
    this.dialog.open(ConfirmActionComponent, {
      width: '400px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      disableClose: true,
      data: {
        title,
        body: '',
        confirmText: 'Yes',
        lottieIconPath: 'assets/lottie/alert.json',
        onConfirm,
        onCancel,
        showCancelButton: true,
        showConfirmButton: true,
      },
    });
  }
  approveApplication() {
    this.openConfirmationModal({
      title: 'Are you sure you want to approve this application?',
      onConfirm: () => {
        this.isApprovingApplication = true;



        this.apiService.post('/workflow/get-next-approving-officer', {
          entityId: this.dialogData?.id,
          workflowName: 'MARRIAGE_REGISTRATION',
          type: 'APPROVED'
        }).pipe(
          finalize(() => {
            this.isApprovingApplication = false;
          })
        ).subscribe((res) => {
          if (res.success) {
            this.openSuccessModal(res.message)
          }
          else {
            this.openErrorModal(res?.error || res?.message);

          }
        },
          (error) => {
            this.openErrorModal(error || 'Unable to approve application');
          })
      },
      onCancel: () => console.log('Approval action cancelled'),
    });
  }



  }
